var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6H1.5C1.10218 6 0.720645 6.15804 0.43934 6.43934C0.158036 6.72064 0 7.10218 0 7.5C0 7.89782 0.158036 8.27936 0.43934 8.56066C0.720645 8.84196 1.10218 9 1.5 9H10.5C10.8978 9 11.2794 8.84196 11.5607 8.56066C11.842 8.27936 12 7.89782 12 7.5C12 7.10218 11.842 6.72064 11.5607 6.43934C11.2794 6.15804 10.8978 6 10.5 6ZM16.5 0H1.5C1.10218 0 0.720645 0.158036 0.43934 0.43934C0.158036 0.720645 0 1.10218 0 1.5C0 1.89782 0.158036 2.27936 0.43934 2.56066C0.720645 2.84196 1.10218 3 1.5 3H16.5C16.8978 3 17.2794 2.84196 17.5607 2.56066C17.842 2.27936 18 1.89782 18 1.5C18 1.10218 17.842 0.720645 17.5607 0.43934C17.2794 0.158036 16.8978 0 16.5 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignName);
export default __webpack_public_path__ + "static/media/CampaignName.33fd431d7e49b10128fc00973fe11312.svg";
export { ForwardRef as ReactComponent };